"use client";

import { useTranslations } from "next-intl";

const ADVANTAGES = [1, 2, 3, 4, 5] as const;
const DISADVANTAGES = [1, 2, 3, 4, 5] as const;

export default function DieCastingProsAndCons() {
	const t = useTranslations("new-die-casting");

	return (
		<section className="bg-[#f5f7fa] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("prosConsTitle")}
					</h2>
				</header>

				<div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
					<div className="overflow-hidden bg-white shadow-card">
						<div className="bg-[#80c26a] px-6 py-3 sm:px-8">
							<h3 className="text-base font-bold text-black sm:text-lg">{t("prosConsAdvantagesTitle")}</h3>
						</div>
						<ul className="space-y-4 bg-[#edffd5] px-6 py-6 sm:space-y-5 sm:px-8 sm:py-8">
							{ADVANTAGES.map((n) => (
								<li key={n} className="text-sm leading-relaxed text-black md:text-base">
									<span className="font-bold">{t(`prosConsAdvantage${n}Title`)}: </span>
									{t(`prosConsAdvantage${n}Desc`)}
								</li>
							))}
						</ul>
					</div>

					<div className="overflow-hidden bg-white shadow-card">
						<div className="bg-[#e5e5e5] px-6 py-3 sm:px-8">
							<h3 className="text-base font-bold text-black sm:text-lg">{t("prosConsDisadvantagesTitle")}</h3>
						</div>
						<ul className="space-y-4 bg-[#f5f5f5] px-6 py-6 sm:space-y-5 sm:px-8 sm:py-8">
							{DISADVANTAGES.map((n) => (
								<li key={n} className="text-sm leading-relaxed text-black md:text-base">
									<span className="font-bold">{t(`prosConsDisadvantage${n}Title`)}: </span>
									{t(`prosConsDisadvantage${n}Desc`)}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
}
